export type AuthKeys<AuthKey extends string> = Record<AuthKey, string>;

export const OAuthStorageKeys = {
  inflightOAuth: "inflightOAuth",
  oauthSignIn: "oauthSignIn",
  oauthPKCE: "oauthPKCE",
  oauthState: "oauthState",
};

export interface KeyValueStorageInterface {
  setItem(key: string, value: string): Promise<void>;
  getItem(key: string): Promise<string | null>;
  removeItem(key: string): Promise<void>;
  clear(): Promise<void>;
}

export function getAuthStorageKeys<T extends Record<string, string>>(
  authKeys: T
) {
  const keys = Object.values({ ...authKeys });

  return (prefix: string, identifier: string) =>
    keys.reduce(
      (acc, authKey) => ({
        ...acc,
        [authKey]: `${prefix}.${identifier}.${authKey}`,
      }),
      {} as AuthKeys<keyof T & string>
    );
}

const createKeysForAuthStorage = (provider: string, identifier: string) => {
  return getAuthStorageKeys(OAuthStorageKeys)(provider, identifier);
};

export async function isOAuthSignInAsync(
  keyValueStorage: KeyValueStorageInterface,
  cognitoConfig: any
) {
  const authKeys = createKeysForAuthStorage(
    "CognitoIdentityServiceProvider",
    cognitoConfig.cognito.clientId
  );

  const [isOAuthSignIn, preferPrivateSession] =
    (await keyValueStorage.getItem(authKeys.oauthSignIn))?.split(",") ?? [];

  return isOAuthSignIn === "true";
}
